export default __webpack_public_path__ + "static/media/bell-avatar.8c33aa3b.webp";